<template>
  <div class="container">
    <div v-if="view==1">
      <CreateQuestion v-if="!course.trainer_owner" :course="course" />
      <div class="mt-5">
        <hr v-if="!course.trainer_owner" style="margin-top:70px" />
        <h6 class="text-muted">Preguntas de este curso</h6>
        <div class="mt-5">
          <div v-for="question in questions" class="mt-3" :key="question.id" @click="verRespuestas(question)">
            <QuestionListItem :question="question" />
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="container">
        <p @click="volverPreguntas" style="cursor:pointer;" class="text-primary mt-3">
          <i class="fas fa-arrow-left"></i> Volver a las preguntas
        </p>
        <ViewAnswers class="mt-5" :course_owner="course.trainer_owner" :question="questionView" />
      </div>
    </div>
  </div>
</template>
<script>
import QuestionListItem from "./QuestionListItem";
import CreateQuestion from "./CreateQuestion";
import ViewAnswers from "./ViewAnswers";

export default {
  data() {
    return {
      view: 1,
      questionView: null
    };
  },
  props: {
    questions: Array,
    course: Object
  },
  created(){
    this.bus.$on("ReturnQuestions", ()=>{
      this.volverPreguntas();
    });
  },
  methods: {
    verRespuestas(question) {
      this.questionView = question;
      this.view = 2;
    },
    volverPreguntas() {
      this.view = 1;
      this.questionView = null;
    }
  },
  components: {
    QuestionListItem,
    CreateQuestion,
    ViewAnswers
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/#public/curse/components/content/ListQuestions.vue